import Styles from '../Registration.module.scss';

const Wrapper = ({ children, noWrap }) =>
  noWrap ? children : <div className={Styles.form}>{children}</div>;

export default Wrapper;
